export const createContestsEditionSurveysRequests = (client) => ({
    getContestsEditionSurveyLinks: async (params) => {
        const { data } = await client.api.request({
            type: "contests_edition_survey_links",
            method: "GET",
            url: "/contests_edition_surveys/links",
            params: params,
        });
        return { data };
    },
    listContestsEditionSurveyResponses: async (params) => {
        const { data, meta } = await client.api.request({
            type: "contests_edition_survey_responses",
            method: "GET",
            url: "/contests_edition_surveys/responses",
            params: params,
        });
        return { data, meta };
    },
});
//# sourceMappingURL=index.js.map